"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlashMessagesProvider = exports.FlashMessagesContext = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("./hooks");
const service_1 = require("./service");
exports.FlashMessagesContext = react_1.default.createContext(service_1.flashMessageService.getFlashMessages());
/**
 * Provider which provides the a flash message context. Should only
 * be used when needing the `FlashMessagesContext`. We recommend
 * using the `useFlashMessages` hook instead were possible.
 *
 * @param children The children to render
 */
function FlashMessagesProvider({ children }) {
    const flashMessages = (0, hooks_1.useFlashMessages)();
    return (react_1.default.createElement(exports.FlashMessagesContext.Provider, { value: flashMessages }, children));
}
exports.FlashMessagesProvider = FlashMessagesProvider;
